"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var permission_1 = require("./model/permission");
var notification_model_1 = require("./model/notification-model");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var WorkflowBaseControlComponent = /** @class */ (function () {
    function WorkflowBaseControlComponent(currentLanguageProvider) {
        this.currentLanguageProvider = currentLanguageProvider;
        this.save = new core_1.EventEmitter();
        this.displayedColumns = ['initial', 'action', 'target', 'condition'];
        this.notification = new notification_model_1.NotificationModel();
        this.destroy$ = new Subject_1.Subject();
    }
    WorkflowBaseControlComponent.prototype.ngOnInit = function () {
        this.getCurrentLanguageId();
    };
    WorkflowBaseControlComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next(true);
        this.destroy$.complete();
    };
    WorkflowBaseControlComponent.prototype.showNotification = function (mode, message) {
        this.saveInProgress = false;
        this.notification.mode = mode;
        this.notification.message = message;
        this.notification.show();
    };
    WorkflowBaseControlComponent.prototype.initializationReady = function () {
        this.isReady = true;
        this.initialized = true;
    };
    WorkflowBaseControlComponent.initWfActionsByState = function (wfActions, currentLanguageId) {
        var map = new Map();
        for (var _i = 0, wfActions_1 = wfActions; _i < wfActions_1.length; _i++) {
            var wfAction = wfActions_1[_i];
            var stateId = wfAction.getInitialStateId();
            if (!map.has(stateId)) {
                map.set(stateId, []);
            }
            map.get(stateId).push(WorkflowBaseControlComponent.constructClassifier(wfAction.getId(), wfAction.getName().getValue(currentLanguageId)));
        }
        return map;
    };
    WorkflowBaseControlComponent.fromKeysMatrix = function (matrix) {
        var data = new Map();
        for (var i = 0; i < matrix.length; i++) {
            var roleId = matrix[i][0];
            var actionId = matrix[i][1];
            var permissionKey = matrix[i][2];
            if (!data.has(roleId)) {
                data.set(roleId, new Map());
            }
            data.get(roleId).set(actionId, permissionKey);
        }
        return data;
    };
    WorkflowBaseControlComponent.initWfStateByAction = function (wfActions, wfStates) {
        var map = new Map();
        var _loop_1 = function (wfAction) {
            var stateId = wfAction.getInitialStateId();
            var actionId = wfAction.getId();
            map.set(actionId, wfStates.find(function (value) { return value.getId() === stateId; }));
        };
        for (var _i = 0, wfActions_2 = wfActions; _i < wfActions_2.length; _i++) {
            var wfAction = wfActions_2[_i];
            _loop_1(wfAction);
        }
        return map;
    };
    WorkflowBaseControlComponent.constructRolesMap = function (roles) {
        var map = new Map();
        roles.forEach(function (role) { return map.set(role.id, role); });
        return map;
    };
    WorkflowBaseControlComponent.initPermissionOptions = function (currentLanguageId, conditionalPermissions) {
        var options = [];
        // add standard options
        options.push(new permission_1.Permission('None', '', true, false));
        options.push(new permission_1.Permission('Full', 'Full', false, true));
        // add already existing options
        for (var _i = 0, conditionalPermissions_1 = conditionalPermissions; _i < conditionalPermissions_1.length; _i++) {
            var conditionalPermission = conditionalPermissions_1[_i];
            var name_1 = conditionalPermission.name[currentLanguageId];
            var expression = conditionalPermission.expression;
            var permissionKey = conditionalPermission.permissionKey;
            options.push(new permission_1.Permission(name_1, name_1, false, false, true, expression, permissionKey));
        }
        return options;
    };
    WorkflowBaseControlComponent.initWfProcessByAction = function (wfStates, wfActions) {
        var map = new Map();
        var _loop_2 = function (wfAction) {
            var stateId = wfAction.getInitialStateId();
            var actionId = wfAction.getId();
            var processId = wfStates.find(function (value) { return value.getId() === stateId; }).getProcessId();
            map.set(actionId, processId);
        };
        for (var _i = 0, wfActions_3 = wfActions; _i < wfActions_3.length; _i++) {
            var wfAction = wfActions_3[_i];
            _loop_2(wfAction);
        }
        return map;
    };
    WorkflowBaseControlComponent.toKeysMatrix = function (data) {
        var matrix = [];
        for (var _i = 0, _a = Array.from(data.keys()); _i < _a.length; _i++) {
            var roleId = _a[_i];
            for (var _b = 0, _c = Array.from(data.get(roleId).keys()); _b < _c.length; _b++) {
                var actionId = _c[_b];
                var permissionKey = data.get(roleId).get(actionId);
                matrix.push([roleId, actionId, permissionKey]);
            }
        }
        return matrix;
    };
    WorkflowBaseControlComponent.preparePermissionsByRoleAndActionMap = function (map, roleId, actionId, initialValue) {
        if (!map.has(roleId)) {
            map.set(roleId, new Map());
        }
        if (!map.get(roleId).has(actionId)) {
            map.get(roleId).set(actionId, initialValue);
        }
    };
    WorkflowBaseControlComponent.initWfTransitions = function (wfActionsByState, actions, states, currentLanguageId) {
        var list = [];
        for (var _i = 0, states_1 = states; _i < states_1.length; _i++) {
            var state = states_1[_i];
            if (wfActionsByState.has(state.getId())) {
                var _loop_3 = function (i) {
                    var action = wfActionsByState.get(state.getId())[i];
                    var initialWfState = WorkflowBaseControlComponent.constructClassifier(state.getId(), i === 0 ? state.getName().getValue(currentLanguageId) : '');
                    var targetStateId = actions.find(function (value) { return value.getId() === action.getId(); }).getTargetStateId();
                    var targetState = states.find(function (value) { return value.getId() === targetStateId; });
                    var targetWfState = WorkflowBaseControlComponent.constructClassifier(targetState.getId(), targetState.getName().getValue(currentLanguageId));
                    list.push({
                        initial: initialWfState,
                        target: targetWfState,
                        action: action,
                    });
                };
                for (var i = 0; i < wfActionsByState.get(state.getId()).length; i++) {
                    _loop_3(i);
                }
            }
        }
        return list;
    };
    WorkflowBaseControlComponent.prepareHierarchy = function (first, second, secondParentField, languageId) {
        var result = new Map();
        for (var _i = 0, first_1 = first; _i < first_1.length; _i++) {
            var firstClassifier = first_1[_i];
            result.set(firstClassifier.getId(), []);
        }
        for (var _a = 0, second_1 = second; _a < second_1.length; _a++) {
            var secondClassifier = second_1[_a];
            var firstClassifierId = secondClassifier.getProperty(secondParentField.getSystemName()).value;
            var name_2 = WorkflowBaseControlComponent.extractName(secondClassifier.getProperty('name').value, languageId);
            result.get(firstClassifierId).push(WorkflowBaseControlComponent.constructClassifier(secondClassifier.getId(), name_2));
        }
        return result;
    };
    WorkflowBaseControlComponent.prepareNonHierarchy = function (firstClassifiers, secondClassifiers, languageId) {
        var result = new Map();
        for (var _i = 0, firstClassifiers_1 = firstClassifiers; _i < firstClassifiers_1.length; _i++) {
            var firstClassifier = firstClassifiers_1[_i];
            result.set(firstClassifier.getId(), secondClassifiers
                .map(function (secondClassifier) {
                var name = WorkflowBaseControlComponent.extractName(secondClassifier.getProperty('name').value, languageId);
                return WorkflowBaseControlComponent.constructClassifier(secondClassifier.getId(), name);
            }));
        }
        return result;
    };
    WorkflowBaseControlComponent.extractName = function (value, languageId) {
        if (typeof value === 'string') {
            return value;
        }
        if (value instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) {
            return value.getValue(languageId);
        }
        return value && value[languageId] ? value[languageId] : '';
    };
    WorkflowBaseControlComponent.constructClassifier = function (id, name) {
        return new idm_classifier_service_client_js_1.ClassifierView(new idm_de_core_frontend_1.ValueAccessorPropertiesBuilder()
            .withNameForValue('id', id)
            .withNameForValue('name', name)
            .buildMap());
    };
    WorkflowBaseControlComponent.prototype.getCurrentLanguageId = function () {
        var _this = this;
        this.currentLanguageProvider.getCurrentLanguage()
            .pipe(operators_1.takeUntil(this.destroy$))
            .subscribe(function (language) {
            _this.currentLanguageId = language.getId();
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], WorkflowBaseControlComponent.prototype, "roleIds", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], WorkflowBaseControlComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], WorkflowBaseControlComponent.prototype, "firstClassifierField", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], WorkflowBaseControlComponent.prototype, "save", void 0);
    return WorkflowBaseControlComponent;
}());
exports.WorkflowBaseControlComponent = WorkflowBaseControlComponent;
//# sourceMappingURL=workflow-base-control.component.js.map